export default {"src":"/_next/static/media/arrow_right.e15a6095.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};